export const fadeTransition = {
  enterFromClass: 'opacity-0',
  enterToClass: 'opacity-100',
  enterActiveClass: 'transition-opacity duration-500',
  leaveFromClass: 'opacity-100',
  leaveToClass: 'opacity-0',
  leaveActiveClass: 'transition-opacity duration-500',
}

export const modalTransition = {
  enterActiveClass: 'transition-all duration-300 ease',
  leaveActiveClass: 'transition-all duration-300 ease',
  enterFromClass: 'opacity-0 transform scale-110',
  leaveToClass: 'opacity-0 transform scale-110',
}
